import { Box, Flex, Text, Progress, Tooltip } from "@chakra-ui/react";
import { AiOutlineInfoCircle } from "react-icons/ai";

// Components
import { Props } from "./StakingLimit.types";
import { numberToCurrency } from "utils/common";
import { useMemo } from "react";
import usePageData from "@hooks/usePageData";
import UndelegationMessage from "@components/UndelegationMessage";
import { useDappSDKProvider } from "dapp-sdk-v2";

const StakingLimit = ({ token }: Props) => {
  const { stakeAmount, limits } = useDappSDKProvider();

  const { staking_limit } = usePageData("$.page.data")[0] || {};

  const utilised = useMemo(() => {
    return limits.stake.used + Number(stakeAmount || 0);
  }, [limits, stakeAmount]);

  const percentage = useMemo(() => {
    return +((utilised / limits.stake.max) * 100).toFixed(2);
  }, [utilised, limits, stakeAmount]);

  return (
    <>
      <Box bg="backgroundPrimary" mt="1rem" p="1rem" borderRadius="12px">
        <Flex
          alignItems="center"
          justifyContent="space-between"
          fontSize={{ base: "12px", md: "14px" }}
          align="center"
          gap="0.5rem"
        >
          <Flex alignItems="center" gap="0.5rem">
            <Text>{staking_limit.title}</Text>
            <Tooltip
              label={staking_limit.tool_tip_text}
              color="textSecondary"
              fontSize="14px"
              bg="tooltipBackground"
              placement="top"
              hasArrow
              p="1rem"
              borderRadius="8px"
            >
              <span>
                <AiOutlineInfoCircle />
              </span>
            </Tooltip>
          </Flex>

          <Box>
            <Text fontWeight={{ base: "700", md: "600" }}>
              {numberToCurrency(utilised.toString())} /{" "}
              {numberToCurrency(limits.stake.max.toString())} {token} (
              {percentage}%)
            </Text>
          </Box>
        </Flex>
        <Progress
          bg="brand.backgroundLight"
          mt="0.5rem"
          value={percentage > 100 ? 100 : percentage}
          size="xs"
          colorScheme="pink"
          borderRadius="4px"
          sx={{
            "& > div": {
              background:
                "linear-gradient(270deg, #07A658 -1%, #cdedde 98.22%);",
            },
          }}
        />
      </Box>

      {limits && limits.stake.used >= limits.stake.max && (
        <Box mt="1rem">
          <UndelegationMessage message={staking_limit.info} />
        </Box>
      )}
    </>
  );
};

export default StakingLimit;
